import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class BranchofficeService {
  constructor(private http: HttpClient, private restService: RestService) {}

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('branchoffice/list', val_params);
  }

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('branchoffice/all', val_params);
  }
}
